import styled, { css, keyframes } from 'styled-components'

export const Wrapper = styled.div`
  width: 30%;
  margin: 0 auto;
  border: 1px solid black;
  min-height: 50px;
  background: White;
  border-radius: 5px;
  padding: 2em;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`

const moveLeft = keyframes`
  0% {transform:translate(0,0);}
  50% {transform:translate(-80px,0);}
  100% {transform:translate(0,0);}
  `

const moveRight = keyframes`
0% {transform:translate(0,0);}
50% {transform:translate(80px,0);}
100% {transform:translate(0,0);}
  `

const moveLeftCSS = css`
  background: red;
  animation: ${moveLeft} 1s ease-in-out both;
`
const moveRightCSS = css`
  background: green;
  animation: ${moveRight} 1s ease-in-out both;
`

export const Box = styled.div`
  width: 20px;
  height: 20px;

  transform-origin: center;
  margin-bottom: 15px;
  ${({ moveDirection }) =>
    moveDirection === 'left'
      ? css`
          background: red;
          animation: ${moveLeft} 1s ease-in-out both;
        `
      : moveDirection === 'right'
      ? css`
          background: green;
          animation: ${moveRight} 1s ease-in-out both;
        `
      : `background: black; animation:none;`}
`

export const MainButton = styled.button`
  margin: 0 10px;
`
export const ButtonContainer = styled.div``
